export default __webpack_public_path__ + "static/media/Inter-UI-ThinItalic-BETA.8bc2290f.woff2";